// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"13f478e7","354":"9c496101","418":"2dda0b46"}[chunkId] + ".js";
};